const config = {
  apiBaseUrl: process.env.REACT_APP_APIBASEURL,
  appUrl: process.env.REACT_APP_APP_URL,
  stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
  currency: process.env.REACT_APP_CURRENCY,
};

module.exports = config;
